import { useState } from 'react';

import Breadcrumb from '../../layouts/Breadcrumb';
import './css/enrollmentScreen.css';

import CulturePost from './compoment/CulturePost';
import CareerOpportunities from './compoment/CareerOpportunities';

import { useNavigate, useParams } from 'react-router-dom';

const tabs = [
  {
    title: 'VĂN HÓA THÀNH ĐỒNG GROUP',
    link: 'van-hoa-thanh-dong-group',
  },
  {
    title: 'CƠ HỘI NGHỀ NGHIỆP',
    link: 'co-hoi-nghe-nghiep',
  },
];

const EnrollmentScreen = () => {
  const navigate = useNavigate();

  const params = useParams();
  const { slug = null } = params;

  return (
    <div>
      <Breadcrumb />

      <section className="enrollment-screen mb-md-5">
        <div className="container">
          <div className="bg-gray ">
            <div className="tabs">
              {tabs.map((tab, index) => {
                const isActive = slug === tab.link;

                return (
                  <div
                    key={index}
                    className="tab"
                    style={{
                      color: isActive ? 'var(--color-primary)' : undefined,
                      fontWeight: isActive ? '700' : undefined,
                      textAlign: 'center',
                      cursor: 'pointer',
                    }}
                    onClick={() => navigate(`/tuyen-dung/${tab.link}`)}
                  >
                    {tab.title}
                  </div>
                );
              })}
            </div>
          </div>

          {slug === 'co-hoi-nghe-nghiep' ? (
            <CareerOpportunities topicSlug={slug} />
          ) : (
            <CulturePost topicSlug={slug} />
          )}
        </div>
      </section>
    </div>
  );
};
export default EnrollmentScreen;
